import {ERROR, START, SUCCESS} from "../../../../../constants/action-postfix";
import {DISEASED_WEEK_REQUEST} from "../diseasedWeekReducer";

const initialState = false;

export const diseasedWeekLoaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${DISEASED_WEEK_REQUEST}${START}`:
            return true;
        case `${DISEASED_WEEK_REQUEST}${SUCCESS}`:
            return false;
        case `${DISEASED_WEEK_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};